<script>
import CustomIcon from 'dashboard/components/ui/CustomIcons.vue';

export default {
  name: 'PlatformBadge',
  components: {
    CustomIcon,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    data() {
      const platforms = {
        FACEBOOK: {
          label: 'Facebook',
          textColor: 'text-[#60646C]',
          bgColor: 'bg-[#F5F5F5]',
        },
        INSTAGRAM: {
          label: 'Instagram',
          textColor: 'text-[#60646C]',
          bgColor: 'bg-[#F5F5F5]',
        },
      };
      return (
        platforms[this.type] || {
          label: 'Desconhecido',
          textColor: 'text-[#000000]',
          bgColor: 'bg-[#F5F5F5]',
          iconColor: '#000000',
        }
      );
    },
  },
};
</script>

<template>
  <div
    :class="`flex items-center gap-2 rounded-lg p-2 text-xs font-semibold ${data.bgColor} ${data.textColor}`"
  >
    <CustomIcon group="platform" :name="type" :color="data.iconColor" />
    <span class="flex-shrink-0">{{ data.label }}</span>
  </div>
</template>
